import { PageCallKeypad } from './call-keypad';

export const PageTransferKeypad = () => {
  return <PageCallKeypad />;
};
